import factory from '@/utils/api/factory';
import request from '../utils/api/request';
import { DEFAULT_CURRENCY } from '@/utils/constants/common';
import { setUser } from '@sentry/browser';

export const state = () => ({
  isLoading: false,
  token: localStorage.getItem('token') || null,
  user: null,
  error: null,
  companies: [],

  publicAccess: null, // PublicAccess token that is to be sent to server as a HEADER
  username: null, // Name of un-identified user of acts with public access

  /**
   * An array of objects of type {type: 'list'|'act-list', row: number, date: string, count: number}
   * to keep track of the read comments in the lists and acts
   */
  commentReads: [],

  registrationInfo: {
    name: '',
    email: '',
    company: '',
  },
  password: null,
});

export const mutations = {
  setToken(state, token) {
    state.token = token;
    localStorage.setItem('token', token);
  },
  setUser(state, user) {
    state.user = user;
  },
  loading(state, data = true) {
    state.isLoading = data;
  },
  error(state, data = null) {
    state.error = data;
  },

  field(state, { name, value }) {
    state[name] = value;
  },

  readComment(state, val) {
    if (!val.type || !val.row || !val.date || !val.count) return;

    const filtered = state.commentReads.filter((record) => record.row !== val.row);
    state.commentReads = [...filtered, val];
  },

  setRegistrationInfo(state, value) {
    state.registrationInfo = {
      ...state.registrationInfo,
      ...value,
    };
  },

  updateRegistrationInfo(state, { key, value }) {
    state.registrationInfo[key] = value;
  },

  setPassword(state, value) {
    state.password = value;
  },
};

export const actions = {
  async load({ commit, state, dispatch }, { silent = false, token = null, toProject = null } = {}) {
    if (token && toProject) {
      commit('setToken', token);
      window.location.href = '/projects';
      // window.location.href = '/project/' + toProject;
      return;
    }

    if (state.token) {
      if (!silent) commit('loading');
      try {
        const { data } = await request.get('/profile/', state.token);
        commit('setUser', data);
        setUser({ id: data.id, email: data.email, username: data.name });
      } catch (e) {
        dispatch('logout');
      }
      if (!silent) commit('loading', false);
    }
  },

  async login({ commit }, { email, password, public_tender_link_hash }) {
    const loginParams = {
      email,
      password,
    };
    if (public_tender_link_hash) {
      loginParams.public_tender_link_hash = public_tender_link_hash;
    }
    const res = await factory('login').create(loginParams);
    commit('setToken', res.data?.token);
    commit('setPassword', null);
  },

  logout({ commit }) {
    commit('loading');
    localStorage.removeItem('token');
    location.href = '/';
  },

  setToken({ commit }, token) {
    commit('setToken', token);
  },

  changeField({ commit }, { name, value }) {
    commit('field', { name, value });
  },

  setPublicAccess({ commit }, hash) {
    commit('field', { name: 'publicAccess', value: hash });
  },

  readComment({ commit }, val) {
    commit('readComment', val);
  },
};

export const getters = {
  getUnreads: (state) => (id, type, last_comment, count) => {
    const reads = state.commentReads.find((record) => record.row === id && record.type === type);

    let ret = 0;
    if ((!reads && last_comment) || reads?.date < last_comment?.date)
      ret = count - (reads?.count || 0);

    return ret;
  },
  companyCurrency: (state) => {
    return state?.user?.membership?.currency || DEFAULT_CURRENCY;
  },
};

export default { namespaced: true, state, mutations, actions, getters };
